import React from 'react'
import { TextValidator } from '@/housefolios-components/shared/muiFormValidator'
import { VALIDATION_RULES } from '@/constants/validation'

const EmailInput = ({ email, setEmail, error, helperText  }) => {
  return (
    <TextValidator
      fullWidth={true}
      variant="outlined"
      label="Email Address"
      value={email}
      onChange={(event) => setEmail(event.target.value)}
      validators={VALIDATION_RULES.email.validators}
      errorMessages={VALIDATION_RULES.email.errorMessages}
      error={error}
      helperText={helperText}
    />
  )
}

export default EmailInput
